<template>
    <b-overlay :show="isLoading">
        <b-card class="m-4">
            <ValidationObserver ref="observer" v-slot="{ passes }">
                <b-form @submit.prevent="passes(saveMembership)" id="customer-form">
                    <b-row class="mb-2">
                        <b-col cols="12" md="6" lg="4" class="text-left">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <b-form-group label="Razón social" invalid-feedback="Ingresa la razón social">
                                    <b-form-input v-model="membership.name" autocomplete="false" placeholder="Razón social"
                                                  :state="errors[0] ? false : null"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6" lg="4" class="text-left">
                            <b-form-group label="RFC" invalid-feedback="Ingresa el RFC">
                                <b-form-input v-model="membership.taxId" autocomplete="false" placeholder="RFC"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6" lg="4" class="text-left">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <b-form-group label="Correo" invalid-feedback="Ingresa el correo">
                                    <b-form-input v-model="membership.email" autocomplete="false" placeholder="Correo"
                                                  :state="errors[0] ? false : null"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6" lg="4" class="text-left">
                            <b-form-group label="Teléfono">
                                <b-form-input v-model="membership.phone" autocomplete="false" placeholder="Teléfono"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6" lg="4" class="text-left">
                            <b-form-group label="Correo de contacto">
                                <b-form-input v-model="membership.contactEmail" autocomplete="false" placeholder="Correo de contacto"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6" lg="4" class="text-left">
                            <b-form-group label="Teléfono de contacto">
                                <b-form-input v-model="membership.contactPhone" autocomplete="false" placeholder="Teléfono de contacto"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" class="text-left">
                            <b-form-group label="Logo">
                                <b-form-file v-model="file" placeholder="Logo" accept="image/jpeg, image/png, image/gif"
                                             browse-text="Seleccionar archivo"></b-form-file>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-form>
            </ValidationObserver>

            <b-row>
                <b-col v-if="oldLogo" cols="12" md="6" :offset-md="logo ? 0 : 3" lg="4" :offset-lg="logo ? 2 : 4">
                    <b-card title="Logo actual" class="mb-2">
                        <b-img :src="oldLogo" alt="Logo actual"></b-img>
                    </b-card>
                </b-col>
                <b-col v-if="logo" cols="12" md="6" :offset-md="oldLogo ? 0 : 3" lg="4" :offset-lg="oldLogo ? 0 : 4">
                    <b-card title="Nuevo logo" class="mb-2">
                        <b-img :src="logo" alt="Logo" style="max-width: 100%;"></b-img>
                    </b-card>
                </b-col>
            </b-row>

            <template v-slot:footer>
                <div class="text-right">
                    <b-button type="submit" form="customer-form" variant="primary"><font-awesome-icon icon="save"></font-awesome-icon> Guardar</b-button>
                </div>
            </template>
        </b-card>
    </b-overlay>
</template>

<script>
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { membershipUrl } from '@routes';
import * as constants from '@constants';

extend('required', {
    ...required,
    message: 'Campo requerido'
});

export default {
    props: {
        application: String
    },
    data() {
        return {
            membership: {
                id: 0,
                name: '',
                taxId: '',
                level: '',
                purchaseDate: '',
                expirationDate: '',
                email: '',
                phone: '',
                contactEmail: '',
                contactPhone: '',
                memberName: '',
                enabled: false
            },
            file: null,
            membershipLabels: [
                { value: '', text: 'Plan' },
                { value: constants.MEMBERSHIP_LEVELS.A, text: constants.MEMBERSHIP_LEVELS.A },
                { value: constants.MEMBERSHIP_LEVELS.B, text: constants.MEMBERSHIP_LEVELS.B },
                { value: constants.MEMBERSHIP_LEVELS.C, text: constants.MEMBERSHIP_LEVELS.C }
            ],
            logo: null,
            oldLogo: null,
            showAddress: false,
            isLoading: false
        }
    },
    created() {
        if (this.$route.name === 'MembershipEdit') {
            this.loadData();
        }
    },
    methods: {
        loadData() {
            this.isLoading = true;

            this.axios.get(membershipUrl(), {
                params: {
                    membershipId: this.$route.params.id
                }
            }).then(response => {
                if (response.data.code === constants.CODE_OK) {
                    let membership = response.data.membership;

                    this.membership.id = membership.id;
                    this.membership.name = membership.name;
                    this.membership.taxId = membership.taxId;
                    this.membership.level = membership.level;
                    this.membership.purchaseDate = membership.purchaseDate;
                    this.membership.expirationDate = membership.expirationDate;
                    this.membership.email = membership.email;
                    this.membership.phone = membership.phone;
                    this.membership.contactEmail = membership.contactEmail;
                    this.membership.contactPhone = membership.contactPhone;
                    this.membership.memberName = membership.memberName;
                    this.membership.enabled = membership.enabled;

                    this.oldLogo = membership.logo;
                }
            }).finally(() => {
                this.isLoading = false;
            });
        },
        saveMembership() {
            this.$swal({
                title: '¿Guardar los cambios?',
                icon: 'question'
            }).then(result => {
                if (result.value) {
                    this.isLoading = true;
                    let formData = new FormData();
                    formData.append('file', this.file);

                    let membership = { ...this.membership };

                    formData.append('membership', JSON.stringify(membership));

                    this.axios.post(membershipUrl(), formData).then(response => {
                        if (response.data.code === constants.CODE_OK) {
                            this.$root.$bvToast.toast(response.data.message, {
                                title: 'Membresías',
                                variant: 'success'
                            });

                            location.reload();
                        } else {
                            this.$bvToast.toast(response.data.message, {
                                title: 'Membresías',
                                variant: 'danger'
                            });
                        }
                    }).catch(error => {
                        console.error(error);

                        this.$bvToast.toast('Ocurrió un error al guardar los cambios.', {
                            title: 'Membresías',
                            variant: 'danger'
                        });
                    }).finally(() => {
                        this.isLoading = false;
                    });
                }
            });
        },
        getLogoBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        }
    },
    watch: {
        file() {
            this.getLogoBase64(this.file).then(result => {
                this.logo = result;
            });
        }
    }
}
</script>

<style scoped>
    label {
        font-weight: 700;
    }
</style>